import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';
import { PanelModule } from 'primeng/panel';
import { FieldsetModule } from 'primeng/fieldset';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ProgressBarModule } from 'primeng/progressbar';
import { PasswordModule } from 'primeng/password';
import { InputGroupModule } from 'primeng/inputgroup';
import { DrawerModule } from 'primeng/drawer';
import { CardModule } from 'primeng/card';
import { TabsModule } from 'primeng/tabs';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TimelineModule } from 'primeng/timeline';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AccordionModule } from 'primeng/accordion';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MessageModule } from 'primeng/message';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { IftaLabelModule } from 'primeng/iftalabel';
import { DividerModule } from 'primeng/divider';
import { PaginatorModule } from 'primeng/paginator';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TreeTableModule } from 'primeng/treetable';
import { DataViewModule } from 'primeng/dataview';
import { BadgeModule } from 'primeng/badge';
import { SpeedDialModule } from 'primeng/speeddial';
import { TreeSelectModule } from 'primeng/treeselect';
import { SplitButtonModule } from 'primeng/splitbutton';
import { DialogModule } from 'primeng/dialog';
import { OrderListModule } from 'primeng/orderlist';
import { PopoverModule } from 'primeng/popover';
import { ContextMenuModule } from 'primeng/contextmenu';
import { RadioButtonModule } from 'primeng/radiobutton';

import { ServerSearchDirective } from '@card-software/nexus-utilities';

const PrimeNG = [
  ServerSearchDirective,
  ProgressSpinnerModule,
  TooltipModule,
  ConfirmDialogModule,
  ButtonModule,
  InputGroupAddonModule,
  MultiSelectModule,
  DatePickerModule,
  InputGroupModule,
  FloatLabelModule,
  InputNumberModule,
  InputTextModule,
  SelectModule,
  PanelModule,
  FieldsetModule,
  CheckboxModule,
  TagModule,
  TableModule,
  BreadcrumbModule,
  PasswordModule,
  DrawerModule,
  CardModule,
  TextareaModule,
  TabsModule,
  IconFieldModule,
  InputIconModule,
  TimelineModule,
  ProgressBarModule,
  AutoCompleteModule,
  ToastModule,
  AccordionModule,
  SelectButtonModule,
  MessageModule,
  MenuModule,
  IftaLabelModule,
  DividerModule,
  PaginatorModule,
  ToggleSwitchModule,
  TreeTableModule,
  DataViewModule,
  BadgeModule,
  SpeedDialModule,
  TreeSelectModule,
  SplitButtonModule,
  DialogModule,
  OrderListModule,
  PopoverModule,
  ContextMenuModule,
  RadioButtonModule,
];
@NgModule({ declarations: [], imports: [CommonModule, PrimeNG], providers: [MessageService, ConfirmationService], exports: [PrimeNG] })
export class PrimengModule {}
